import './Table.scss'

const Table = ({ rows, columns, rowNumbers = false }) => {
    return (
        <table className="table">
            <thead>
                <tr>
                    {rowNumbers && <td className="table-heading"></td>}
                    {columns.map((column) => (
                        <td className={`table-heading ${column.className?.heading || ''}`} key={column.name}><b>{column.label}</b></td>
                    ))}
                </tr>
            </thead>

            <tbody>
                {rows.map((row, rowIndex) => (
                    <tr className={`table-row ${row.className || ''}`} key={rowIndex}>
                        {rowNumbers && <td className="table-data">{rowIndex + 1}</td>}
                        {columns.map((column) => (
                            <td className={`table-data ${column.className?.cell || ''}`} key={column.name}>{column.content ? column.content(row, rowIndex) : row[column.name]}</td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default Table